// veh_type_group/VehTypeGroupGql.js
import { gql } from "@apollo/client";


const VEH_TYPE_GROUP_LIST_PART = gql`
fragment VehTypeGroupListPart on VehTypeGroup {
	vehTypeGpCd
    groupName
    dcTypeCd
    dcTypeName
	dcCd
    dcName
    dcUseYn
	regDate
	regUser
    userName
}
`;

const VEH_TYPE_GROUP_NO_LIST_PART = gql`
fragment VehTypeGroupNoListPart on VehTypeGroup {
	groupMemo
}
`;


export const LIST_VEH_TYPE_GROUP = gql`
${VEH_TYPE_GROUP_LIST_PART}
query ListVehTypeGroup {
    vehTypeGroupList {
        ...VehTypeGroupListPart
    }
}
`;

export const GET_VEH_TYPE_GROUP = gql`
${VEH_TYPE_GROUP_LIST_PART}
${VEH_TYPE_GROUP_NO_LIST_PART}
query GetVehTypeGroup($vehTypeGpCd:String!, $dcCd:String!) {
    vehTypeGroupItem(vehTypeGpCd:$vehTypeGpCd, dcCd:$dcCd) {
        ...VehTypeGroupListPart
        ...VehTypeGroupNoListPart
    }
}
`;

export const ADD_VEH_TYPE_GROUP = gql`
${VEH_TYPE_GROUP_LIST_PART}
mutation AddVehTypeGroup($vehTypeGroup:InputVehTypeGroupAdd!) {
    vehTypeGroupAdd(vehTypeGroup: $vehTypeGroup) {
        ok
        message
        list {
            ...VehTypeGroupListPart
        }
    }
}
`;

export const EDIT_VEH_TYPE_GROUP = gql`
${VEH_TYPE_GROUP_LIST_PART}
mutation EditVehTypeGroup($vehTypeGroup:InputVehTypeGroupEdit!) {
    vehTypeGroupEdit(vehTypeGroup: $vehTypeGroup) {
        ok
        message
        list {
            ...VehTypeGroupListPart
        }
    }
}
`;

export const REMOVE_VEH_TYPE_GROUP = gql`
${VEH_TYPE_GROUP_LIST_PART}
mutation RemoveVehTypeGroup($vehTypeGroup:InputVehTypeGroupRemove!) {
    vehTypeGroupRemove(vehTypeGroup: $vehTypeGroup) {
        ok
        message
        list {
            ...VehTypeGroupListPart
        }
    }
}
`;

export function makeVehTypeGroupTree(list) {
    const tree = []; // {dcTypeCd: {dcTypeName, children: {dcCd, dcname, vehTypeGpCd, groupName, dcUseYn,...}}}
    const typeMap = {};
    list.forEach(record => {
        if(!typeMap[record.dcTypeCd]) {
            typeMap[record.dcTypeCd] = {dcTypeCd:record.dcTypeCd, dcTypeName: record.dcTypeName, children: []};
            tree.push(typeMap[record.dcTypeCd]);
        }
        typeMap[record.dcTypeCd].children.push(record);
    });
    return tree;
}

/*

extend type Query {
	vehTypeGroupList: [VehTypeGroup]!
	vehTypeGroupItem(vehTypeGpCd:String,dcCd:String): VehTypeGroup
}

extend type Mutation {
	vehTypeGroupAdd(vehTypeGroup: InputVehTypeGroupAdd!): ResponseWithVehTypeGroup
	vehTypeGroupEdit(vehTypeGroup: InputVehTypeGroupEdit!): ResponseWithVehTypeGroup
	vehTypeGroupRemove(vehTypeGroup: InputVehTypeGroupRemove!): ResponseWithVehTypeGroup
}

type VehTypeGroup {
	vehTypeGpCd: String
    groupName: String
    dcTypeCd: String
    dcTypeName: String
	dcCd: String
    dcName: String
    dcUseYn: String
	groupMemo: String
	regDate: String
	regUser: String
    userName: String
}



input InputVehTypeGroupAdd {
	vehTypeGpCd: String!
	dcCd: String!
	groupMemo: String
}

input InputVehTypeGroupEdit {
	vehTypeGpCd: String!
	dcCd: String!
	groupMemo: String
}

input InputVehTypeGroupRemove {
	vehTypeGpCd: String!
	dcCd: String!
}

type ResponseWithVehTypeGroup {
    ok: Boolean!
    message: String
    list: [VehTypeGroup]
}

*/
